import React from "react";
import ProductCard from "../ProductCard/ProductCard";
import { Product } from "../../interfaces/IProduct";

interface Props {
  products: Product[];
  refs: React.MutableRefObject<Record<number, HTMLDivElement | null>>;
  highlighted: number | null;
  onDelete(id: number): void;
  onInc(id: number): void;
  onDec(id: number): void;
}

export default function ProductList({ products, refs, highlighted, onDelete, onInc, onDec }: Props) {
  return (
    <>
      {products.map(p => (
        <div
          key={p.id}
          ref={el => (refs.current[p.id] = el)}
          style={{
            border: "2px solid",
            borderColor: highlighted === p.id ? "orange" : "transparent",
            borderRadius: 10,
          }}
        >
          <ProductCard
            {...p}
            onDelete={() => onDelete(p.id)}
            onIncreaseAmount={() => onInc(p.id)}
            onDecreaseAmount={() => onDec(p.id)}
          />
        </div>
      ))}
    </>
  );
}